module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share"
  }, [_c('div', {
    staticClass: "player-list"
  }, [(_vm.isNotExist) ? _c('div', {
    staticClass: "notexist",
    attrs: {
      "id": "notexist"
    }
  }, [_vm._v("\n            " + _vm._s("分享播放地址已停用或者过期！") + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isShow) ? _c('div', {
    staticClass: "player-card",
    class: {
      'fs-fallback': _vm.fsFallback, 'fs-rotate': _vm.fsRotate
    },
    style: (_vm.cardStyle)
  }, [_c('div', {
    staticClass: "player-title"
  }, [_vm._v(_vm._s(_vm.movie_title))]), _vm._v(" "), _c('div', {
    staticClass: "video-wrap",
    style: (_vm.videoWrapStyle)
  }, [(_vm.playerVisible) ? _c('eu-player', {
    ref: "player",
    attrs: {
      "source": _vm.scriptUrl,
      "autoplay": false,
      "container-id": "share-player-canvas"
    },
    on: {
      "playComplete": _vm.onPlayComplete,
      "loaded": _vm.onPlayerLoaded
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.started) ? _c('div', {
    staticClass: "player-cover",
    style: (_vm.coverStyle),
    on: {
      "click": _vm.startPlay
    }
  }, [_c('i', {
    staticClass: "el-icon-video-play"
  })]) : _vm._e(), _vm._v(" "), (_vm.playerVisible && _vm.isFinished) ? _c('div', {
    staticClass: "replay-mask",
    on: {
      "click": _vm.replay
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh-right"
  }), _vm._v(" "), _c('span', [_vm._v("重新播放")])]) : _vm._e()], 1), _vm._v(" "), (_vm.playerVisible) ? _c('div', {
    staticClass: "controls"
  }, [_c('button', {
    staticClass: "ctrl-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.togglePlay
    }
  }, [_c('i', {
    class: _vm.isFinished || !_vm.isPlaying ? 'el-icon-video-play' : 'el-icon-video-pause'
  })]), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.fmt(_vm.displayTime)))]), _vm._v(" "), _c('input', {
    staticClass: "progress",
    style: ({
      background: _vm.progressBg
    }),
    attrs: {
      "type": "range",
      "min": 0,
      "max": _vm.duration || 1000
    },
    domProps: {
      "value": _vm.displayTime
    },
    on: {
      "input": _vm.onSeekInput,
      "change": _vm.onSeekChange,
      "mousedown": _vm.onDragStart,
      "touchstart": _vm.onDragStart
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.fmt(_vm.duration)))]), _vm._v(" "), _c('button', {
    staticClass: "ctrl-btn",
    attrs: {
      "type": "button",
      "title": "全屏"
    },
    on: {
      "click": _vm.toggleFullscreen
    }
  }, [_c('i', {
    staticClass: "el-icon-full-screen"
  })])]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2ef0946","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Share/Share.vue
// module id = 403
// module chunks = 0